import { withInstall } from '../utils'

import Com from './src/index.vue'

export const GroupOfficeSelector = withInstall(Com)
